import { Alert, Button, Heading, TextInput } from '@digitools/honest-react';
import { Col, Container, Row } from '@digitools/honest-react';
import { Form } from 'informed';
import React, { useContext, useEffect, useState } from 'react';
import useRequiredField from '../../../../../hooks/fieldValidation/useRequiredField';
import { ExperienceContext } from 'src/providers/ExperienceProvider';
import { Language } from 'src/types/Language';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getEnvVariable } from 'src/utils/envUtils';
import useTealium from 'src/hooks/useTealium';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
import axios from "axios";
import useMediaQuery from "src/hooks/useMediaQuery";
const CompanyCode = (props) => {
    const { trackEvent } = useTealium();
    const { validEmployerRegCode, setValidEmployerRegCode, employeeRegistrationAllowed, validateCompanyCode, getLocalDisplayText, history, companyCode, companyName } = props;
    const [formApi, setFormApi] = useState();
    const { language } = useContext(ExperienceContext);
    const navigate = useNavigate();
    const validateRequired = useRequiredField({
        [Language.ENGLISH]: 'Company Code',
        [Language.SPANISH]: 'Código de Compañía',
    });
    const [queryParams] = useSearchParams();
    const token = queryParams.get('token') || undefined;
    const state = queryParams.get('state') || undefined;
    const [unexpectedAuthError, setUnexpectedAuthError] = useState(false);
    const isMobile = useMediaQuery('(max-width: 768px)');
    const isSSOERRegEnabled = getEnvVariable('LfgSsoErRegistrationEnabled');
    const validateAuthToken = async (token, regCode) => {
        await axios.post(`/auth-service/services/v1/auth0/app-metadata`, {
            "token": token,
            "state": state,
            "appMetadata": {
                "registrationCode": regCode
            }
        }).catch(() => {
            setUnexpectedAuthError(true);
        });
    };
    useEffect(() => {
        //if valid company code and user exists show "access benefits for:" message with yes/cancel buttons
        if (validEmployerRegCode === false) {
            formApi.setError('companyCode', getLocalDisplayText('companyCodeError'));
        }
        if (!employeeRegistrationAllowed) {
            formApi.setError('companyCode', getLocalDisplayText('employeeCompanyCodeError'));
            trackEvent({
                event_action: TEALIUM_EVENT.EVENT_ACTION.ERROR,
                event_name: getLocalDisplayText('employeeCompanyCodeError'),
                event_type: TEALIUM_EVENT.EVENT_TYPE.MIGRATION,
                event_version: TEALIUM_EVENT.EVENT_VERSION.BLOCK_REGISTRATION,
            });
        }
    }, [validEmployerRegCode, employeeRegistrationAllowed, language]);
    const getFormApi = (api) => {
        setFormApi(api);
    };
    const handleCancelClick = () => {
        navigate('/public/login');
    };
    return (<>
            <Container>
                <Row>
                    <Col>
                        <Heading elemType={'h1'} elemStyle={'h2'} data-testid={'pageHeading'} id='pageHeading' color='secondaryDarker'>
                            {(isSSOERRegEnabled && token) ? getLocalDisplayText('accountAccess') : getLocalDisplayText('pageHeading')}
                        </Heading>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {(!isSSOERRegEnabled || validEmployerRegCode !== true) && (<p id='registrationInfoText' data-testid={'registrationInfoText'}>
                            {(isSSOERRegEnabled && token) ? getLocalDisplayText('registrationInfoTextCompanyCodeCcm') : getLocalDisplayText('registrationInfoTextCompanyCode')}
                        </p>)}
                        {(!isSSOERRegEnabled || !token) && (<p>{getLocalDisplayText('companyCodeToolTip')}</p>)}
                    </Col>
                </Row>
                {(isSSOERRegEnabled && validEmployerRegCode === true && token !== undefined) ? (<>
                        <p className={'mt-0'} data-testid={'accessClaimsPortalText'}>{getLocalDisplayText('accessClaimsPortalText')}<b><i>{companyName}</i></b>? </p>
                        <Row><Button onClick={() => validateAuthToken(token, companyCode)} className={isMobile ? 'ml-2 mb-2 w-100' : 'ml-2 mb-2'} buttonType={'primary'}>{getLocalDisplayText('continueButton')}</Button>
                            <Button onClick={() => setValidEmployerRegCode(null)} className={isMobile ? 'ml-2 mb-2 w-100' : 'ml-2 mb-2'} buttonType={'secondary'}>{getLocalDisplayText('cancelButtonLabel')}</Button></Row>
                        {unexpectedAuthError && (<Alert type={'error'}>{getLocalDisplayText('unexpectedAuthError')}</Alert>)}
                    </>) :
            (<Form onSubmit={validateCompanyCode} getApi={getFormApi} className={'mt-4'}>
                <Row>
                    <Col md={'6'}>
                        <TextInput field='companyCode' label={getLocalDisplayText('companyCodeLabel')} validate={validateRequired} validateOnBlur={true} data-testid={'companyCode'}/>
                    </Col>
                </Row>
                <Button aria-label={'validate company code'} className={token && isMobile ? 'mt-3 mb-2 w-100' : 'mt-3 mb-2 '} data-testid={'validateCodeButton'} buttonType={'primary'} id={'validateButton'} type={'submit'}>
                    {getLocalDisplayText('validateButton')}
                </Button>
                {(!isSSOERRegEnabled || !token) && (<Button aria-label={'return to login'} buttonType={'secondary'} className={'mt-3 mb-2'} data-testid={'returnToLoginButton'} onClick={handleCancelClick} type={'button'}>
                    {getLocalDisplayText('cancelButtonLabel')}
                </Button>)}
                        {(isSSOERRegEnabled || token) && (<Row className={'mt-2'}>
                                <Col>
                                    <p>{getLocalDisplayText('companyCodeToolTip')}</p>
                                </Col>
                            </Row>)}
            </Form>)}
            </Container>
        </>);
};
export default CompanyCode;
